import axios from "axios";
import { addMinutes, format } from "date-fns";
import { DateTime } from "luxon";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import SessionTile from "../../components/SessionTile";
import { useLocalStorage } from "../../hooks";
import * as dashboardActions from "../../redux/reducers/dashboardReducer";
import { dashboardState } from "../../redux/reducers/dashboardReducer";
import { userState } from "../../redux/reducers/userReducer";


import { useLocation } from "react-router-dom";
import { TwButton, TwLoadingIcon } from "../../components/tailwind";
import { useToast } from "../../provider/ToastProvider";
import { setGlobalLoading } from "../../redux/reducers/loadingReducer";
import { getUrlForEvent } from "../../utils/confighelpers";
import { useTranslation } from "react-i18next";


export default function UpcomingEventActivites({ }) {
    const { t, i18n } = useTranslation();
    const { addToast, addSuccessToast, addErrorToast } = useToast();
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [userToken] = useLocalStorage("userToken");
    const userReduxState = useSelector(userState);
    const dashboardReduxState = useSelector(dashboardState);

    const [loading, setLoading] = React.useState(false);
    const [scheduledClasses, setSceduledClasses] = React.useState([]);
    const [classList, setClassList] = React.useState([]);



    const handleSessionClick = async (id, eventData) => {
        if (dashboardReduxState.calendarSessionId === id) {
            dispatch(dashboardActions.setCalendarSessionId(-1));
            dispatch(dashboardActions.setCalendarOpen(false));
            navigate("/home/dashboard");
            return;
        }
        addToast(t("myschedule.loadingSessionDetails"));
        const isPckg = eventData.isPackage;
        const config = {
            method: "get",
            url: `${getUrlForEvent()}schedule/get?eventScheduleId=${id}&isPackage=${isPckg}`,
            headers: {
                "x-access-token": userToken,
            },
        };
        dispatch(setGlobalLoading(true));
        const request = await axios(config);
        dispatch(setGlobalLoading(false));
        if (request.status === 200) {
            if (request.data.statusCode === 200) {

                dispatch(dashboardActions.setEventId(request.data.data.eventId._id));
                dispatch(dashboardActions.setEventData(request.data.data.eventId));
                dispatch(dashboardActions.setCalendarSessionId(id));
                dispatch(dashboardActions.setEventScheduleId(request.data.data._id));
                dispatch(dashboardActions.setEventScheduleData(request.data.data));
                dispatch(dashboardActions.setViewSessionPage(true));
                // navigate("/dashboard/ViewSessionDetails");
                navigate("/myschedule/detail");
            }
        }
    };



    const upcomingSessionsApi = async () => {
        const scheduledClassesConfig = {
            method: "get",
            url: `${getUrlForEvent()}groupScheduledEvent?listFor=${userReduxState.businessType}`,
            headers: {
                "x-access-token": userToken.toString(),
            },
        };
        dispatch(setGlobalLoading(true));
        const scheduledClassesRequest = await axios(scheduledClassesConfig);
        dispatch(setGlobalLoading(false));
        if (scheduledClassesRequest.status === 200) {
            let schedClasses = [];
            for (const item of scheduledClassesRequest.data.data) {
                const dtStart = DateTime.fromISO(item.eventDate);
                const dtEnd = format(addMinutes(dtStart.ts, item.duration), "HH:mm");

                let ticketQty = 0;
                let ticketsBooked = 0;

                if (item?.eventPricingList && item.eventPricingList.length > 0) {
                    item.eventPricingList.map((booking) => {
                        ticketQty = parseInt(ticketQty) + parseInt(booking.capacity);
                        ticketsBooked = parseInt(ticketsBooked) + parseInt(booking?.ticketsBooked ? booking.ticketsBooked.ticketsBookedConfirmed : 0);
                    })
                } else {
                    if (item.scheduleClassBookings && item.scheduleClassBookings.length > 0) {
                        ticketQty = 0;
                        item.scheduleClassBookings.map((booking) => {
                            if (booking.status === "Cancelled") {
                                return booking;
                            }
                            if (booking.ticketsBought && booking.ticketsBought.length > 0) {
                                booking.ticketsBought.map((ticket) => {
                                    ticketsBooked = parseInt(parseInt(ticketsBooked) + parseInt(ticket.bookingQty))
                                })
                            } else {
                                ticketsBooked = parseInt(ticketsBooked) + parseInt(booking.capacity ? booking.capacity : 0);
                            }
                        })
                    } else {
                        ticketQty = 0;
                        ticketsBooked = 0;
                    }
                }

                let newClass = {
                    dataFor: "event",
                    id: item._id,
                    imgSrc: item.eventPhoto,
                    title: item.eventName,
                    time: `${dtStart.toFormat("dd LLL, ccc, HH:mm")} - ${dtEnd}`,
                    venue: item?.location?.addressName ? item.location.addressName : `${item.location.houseNumber}, ${item.location.city}`,
                    totalSeats: ticketQty || 0,
                    seatsBooked: ticketsBooked,
                    seatsBookedPerc: (ticketsBooked / ticketQty) * 100,
                    bookedPeople: item.scheduleClassBookings,
                    popover: false,
                    sessionObj: item,
                };
                schedClasses.push(newClass);
            }
            setSceduledClasses([...schedClasses]);
        }
    };
    const getListOfClass = async () => {
        let mgClasses = [];
        const manageClassesConfig = {
            method: "get",
            url: `${getUrlForEvent()}list?listFor=${userReduxState.businessType}`,
            headers: {
                "x-access-token": userToken,
            },
        };
        setLoading(true)
        const manageClassesRequest = await axios(manageClassesConfig);
        setLoading(false)
        if (manageClassesRequest.status === 200) {
            if (manageClassesRequest.data.data.length) {
                for (const item of manageClassesRequest.data.data) {
                    mgClasses.push({
                        label: item.eventName,
                        id: item._id,
                        data: item
                    });
                }
                setClassList(mgClasses);
            }
        }
    };

    React.useEffect(() => {
        getListOfClass();
        upcomingSessionsApi();
    }, []);


    return (
        <div className={`max-w-7xl px-5 py-2 [pb-10] bg-white rounded-2xl`}>
            <div className={"flex flex-row justify-between items-center my-4"} >
                <h3 className={"font-extrabold text-lg sm:text-base md:text-base"} >
                    Upcoming Events
                </h3>
                <p
                    className={"font-extrabold text-primary text-sm cursor-pointer"}
                    onClick={(e) => {
                        navigate("/myschedule", { replace: true });
                    }}
                >
                    {t("inputFieldsTitle.viewAll")}
                </p>
            </div>
            {loading ? (
                <div className={"h-28 w-full grid place-items-center"}>
                    <TwLoadingIcon />
                </div>
            ) : Array.isArray(scheduledClasses) &&
                scheduledClasses.length > 0 ? (
                <div
                    className={
                        "flex flex-col gap-5 sm:flex-row sm:gap-4 overflow-x-auto"
                    }
                >
                    {scheduledClasses.map((session, i) => (
                        <SessionTile {...session} key={i} onClick={() =>
                            handleSessionClick(
                                session.sessionObj.instanceId,
                                session.sessionObj
                            )
                        } />
                    ))}
                </div>
            ) : (
                <div className={`h-48 flex justify-center items-center`}>
                    {classList.length ? (<p className={"text-lg sm:text-2xl"}>
                        Your upcoming sessions will appear here
                    </p>) : (
                        <div className="flex flex-col gap-4 justify-center items-center w-full">
                            <div className="text-lg sm:text-2xl text-center">
                                No Upcoming Activities Configured
                            </div>
                            <TwButton
                                className="sm:w-1/5"
                                onClick={() => {
                                    navigate("/myevents/new");
                                }}
                            >
                                {t("myEvents.addNewEvent")}
                            </TwButton>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
